import React from "react";
import {
  Card,
  CardContent,
  Stack,
  Typography,
  Chip,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";

import DescriptionIcon from "@mui/icons-material/Description";

function ReportCategory({
  title,
  icon,
  chipColor = "primary",
  reports = [],
  onView,
}) {
  return (
    <Card elevation={4} sx={{ height: "100%" }}>
      <CardContent >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 ,backgroundColor: "#f0c8c8", p: 1, borderRadius: 2 }}>
        <Stack direction="row" spacing={3} alignItems="center" mb={2} >
          {icon}

          <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>

          <Chip
            label={`${reports.length} Report${reports.length > 1 ? "s" : ""}`}
            color={chipColor}
            size="small"
            
          />
        </Stack>
</Box>
        <List disablePadding>
          {reports.map((report) => (
            <ListItemButton
              key={report.id || report.name}
              onClick={() => onView?.(report)}
              sx={{
                mb: 1,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                "&:hover": {
                  bgcolor: "#f0f0f0",
                 // color: "primary.contrastText",
                },
              }}
            >
              <ListItemIcon>
                <DescriptionIcon color="primary" />
              </ListItemIcon>

              <ListItemText
                primary={report.name}
                secondary={report.description}
              />
            </ListItemButton>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}

export default ReportCategory;